module.exports = __webpack_public_path__ + "static/media/incorrect.33c11cf7.png";